import styled from 'styled-components';
import { Alert } from 'antd';


export const FormContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-bottom: 35px;
`;
export const FormDiv = styled.div`
  width: 100%;
  padding: 1.875rem 0 2rem;
  display: flex;
  flex-direction: column;
  // Large Screens
  @media (max-width: 1440px) {
    padding: 0.31rem 0 1rem;
  }
`;
export const QueryDiv = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  margin-bottom: 0.5rem;
`;
export const Query = styled.p`
  font-size: 0.93rem;
  font-weight: 400;
  display: flex;
  color: #ffffff;
`;
export const AlertBox = styled(Alert)`
  margin-top: 10px;
  height: auto;
  padding: 10px;
`;
export const MyForm = styled.form``;
